import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  HostListener
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders
} from '@angular/common/http';

import {AuthService} from '../auth.service';
import {MustMatch} from '../../_helpers/matchpassword';

import {environment} from './../../../environments/environment';
import {ApiHelper} from './../../_helpers/api.helper';
import {CommonHelper} from './../../_helpers/common.helper';
import {AppConfig} from './../../../app/app.config';
import {ConstantHelper} from './../../_helpers/constant.helper';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AppConfig, CommonHelper]
})
export class LoginComponent implements OnInit {
  @ViewChild('recaptcha', {static: false}) recaptchaElement: ElementRef;
  @HostListener('window:resize', ['$event'])
  loginForm: FormGroup;
  loginFromSubmitted: boolean = false;
  formErrorMessage: boolean = false;
  showLoginForm = true;
  verifyLoginOtpForm: FormGroup;
  verifyLoginOtpFormSubmitted: boolean = false;
  verifyLoginFormErrorMessage: boolean = false;
  showVerifyLoginOtpForm = false;
  userOtp: number;
  userId: number;
  userEmail: string;
  userMobile: string;
  userRoleId: number;
  resultJsonObj: any = {};
  formRecaptchaErrorMessage = false;
  pId: any = '';
  fieldTextType: boolean;

  constructor(public commonHelper: CommonHelper,
              private appConfig: AppConfig,
              private formBuilder: FormBuilder,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private http: HttpClient) {

  }

  ngOnInit() {
    this.pId = this.activatedRoute.snapshot.paramMap.get('pId');
    localStorage.removeItem('loggedInUserName');
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      recaptchaValue: ['', Validators.required]
    });

    this.verifyLoginOtpForm = this.formBuilder.group({
      otp: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  get v() {
    return this.verifyLoginOtpForm.controls;
  }

  onSubmit() {
    this.loginFromSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: httpHeaders
    };
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      email: this.loginForm.value.email,
      password: this.loginForm.value.password
    };

    return this.http
      .post(
        this.appConfig.getLambdaUrl01() + ApiHelper.name_loginApi,
        finalData,
        options
      )
      .subscribe(
        apiResponse => {
          // console.log(apiResponse);
          this.resultJsonObj = apiResponse;

          if (this.resultJsonObj.commandResult.status == 1) {
            this.userId = this.resultJsonObj.commandResult.data.userInfo.Id;
            this.userOtp = this.resultJsonObj.commandResult.data.userInfo.Otp;
            this.showLoginForm = false;
            this.showVerifyLoginOtpForm = true;
          } else {
            this.formErrorMessage = true;
          }
        },
        err => {
          // console.log(err);
        }
      );
  }

  verifyOtp(verifyLoginOtpFormValue) {
    this.verifyLoginOtpFormSubmitted = true;

    // stop here if form is invalid
    if (this.verifyLoginOtpForm.invalid) {
      return;
    }

    if (
      this.verifyLoginOtpForm.value.otp.toString().trim() !=
      this.userOtp.toString().trim()
    ) {
      this.verifyLoginFormErrorMessage = true;
    } else {
      let httpHeaders = new HttpHeaders({
        // "Content-Type": "application/x-www-form-urlencoded"
        'Content-Type': 'application/json'
      });
      let options = {
        headers: httpHeaders
      };
      const finalData = {
        otp: this.verifyLoginOtpForm.value.otp,
        id: this.userId
      };

      return this.http
        .post(
          this.appConfig.getLambdaUrl01() + ApiHelper.name_verifyLoginOtpApi,
          finalData,
          options
        )
        .subscribe(
          apiResponse => {
            // console.log(apiResponse);
            // return
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              this.userId = this.resultJsonObj.commandResult.data.userInfo.RecordId;

              localStorage.setItem('loggedInUserName', this.resultJsonObj.commandResult.data.userInfo.FullName);
              localStorage.setItem('loggedInUserEmail', this.resultJsonObj.commandResult.data.userInfo.Email);
              localStorage.setItem('loggedInUserRoleId', this.resultJsonObj.commandResult.data.userInfo.UserRoleId);
              localStorage.setItem('loggedInUserComapnyId', this.resultJsonObj.commandResult.data.userInfo.ComapnyId);

              if (this.resultJsonObj.commandResult.data.userInfo.UserRoleId == 2) {
                if (this.pId && this.pId.length > 0) {
                  this.router.navigate(['/view-docs/' + this.pId + '/' + this.userId]);
                } else {
                  this.router.navigate(['/dashboard/' + this.userId]);
                }

              }
              if (
                this.resultJsonObj.commandResult.data.userInfo.UserRoleId == 1
              ) {
                this.router.navigate(['/admin/users/' + this.userId]);
              }
            } else {
              this.verifyLoginFormErrorMessage = true;
            }
          },
          err => {
            // console.log(err);
          }
        );
    }

    // this.authService.createRegistration(this.registrationForm.value);
    // this.router.navigate(["/demographicsform"]);
  }

  renderReCaptch() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      sitekey: ConstantHelper.RECAPTCHA_SITE_KEY_CLIENT,
      callback: response => {
        // console.log(
        //   this.appConfig.getLambdaUrl01() + ApiHelper.name_verifyRecaptachaApi
        // );
        // console.log(response);
        this.loginForm.get('recaptchaValue').setValue(response);

        ///////////////////recaptcha validation /////////////////
        let httpHeaders = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let options = {
          headers: httpHeaders
        };
        const finalData = {
          recaptchaResponse: response
        };
        return this.http
          .post(
            this.appConfig.getLambdaUrl01() +
            ApiHelper.name_verifyRecaptachaApi,
            finalData,
            options
          )
          .subscribe(
            apiResponse => {
              // console.log(apiResponse);
              this.resultJsonObj = apiResponse;
              // console.log(this.resultJsonObj);

              if (this.resultJsonObj.commandResult.status == 1) {
                this.formRecaptchaErrorMessage = false;
              } else {
                this.formRecaptchaErrorMessage = true;
              }
            },
            err => {
              // console.log(err);
            }
          );
        /////////////////////////////////////////////////////////
      }
    });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    };

    (function(d, s, id, obj) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptch();
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src =
        'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'recaptcha-jssdk', this);
  }

  ngAfterViewInit() {
    this.addRecaptchaScript();
    this.captchScaleFunc();
  }

  onResize(event) {
    this.captchScaleFunc();
  }

  captchScaleFunc() {
    var captchacontainWidth = this.recaptchaElement.nativeElement.clientWidth;
    var scaleValue = captchacontainWidth / 304;
    if (scaleValue < 1) {
      this.recaptchaElement.nativeElement.style.transform =
        'scale(' + scaleValue + ')';
      this.recaptchaElement.nativeElement.style.transformOrigin = '0';
    }
    // console.log(captchacontainWidth);
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
}
